import { api } from "@/lib/api";

export async function runJudgmentSimulation(analysisId, { force = false } = {}) {
  const { data } = await api.post(
    `/analyses/${analysisId}/judgment`,
    { force, acknowledgement: true },
    { timeout: 180000 }
  );
  return data;
}
